import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { ReactComponent as DeleteIcon } from '../../../../images/icons/delete_icon.svg';
import { dimGrey } from '../../../../mainTheme';

const typography = {
  heading: {
    fontWeight: 500,
    fontSize: '22px',
    lineHeight: '30px',
    letterSpacing: '0.36px',
  },
  subText: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: '0.2px',
    color: dimGrey,
  },
} as const;

interface Props {
  contact: { first_name: string; last_name: string };
  onClose: () => void;
  onDelete: () => void;
  isLoading?: boolean;
}

const DeleteCareTeamUserModal: React.FC<Props> = ({
  contact,
  onClose,
  onDelete,
  isLoading = false,
}) => {
  const [confirmationText, setConfirmationText] = useState('');

  return (
    <Box>
      <Box>
        <DeleteIcon />
        <Typography sx={typography.heading}>
          {contact.first_name} {contact.last_name}
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '22px',
            letterSpacing: '0.2px',
            color: dimGrey,
            mt: 1,
          }}
        >
          This user will be deleted from the care team.
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" py={4} gap="8px">
        <Typography sx={{ ...typography.subText, fontWeight: 700, ml: 2 }}>
          Type the word &quot;delete&quot; to confirm.
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          disabled={isLoading}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              color: 'black',
            },
          }}
          placeholder="Type 'delete'"
        />
      </Box>
      <Box width="100%" display="flex" justifyContent="center" gap={3} px={2}>
        <Button
          variant="text"
          color="secondary"
          fullWidth
          onClick={onClose}
          sx={{
            padding: '14px 24px 12px 24px',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '18px',
            letterSpacing: '0.2px',
            height: '44px',
          }}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={() => {
            if (confirmationText === 'delete') onDelete();
          }}
          disabled={confirmationText !== 'delete' || isLoading}
          sx={{
            padding: '14px 24px 12px 24px',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '18px',
            letterSpacing: '0.2px',
            height: '44px',
          }}
        >
          Delete
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteCareTeamUserModal;
